import type {
  StoreDashboardActiveUsers,
  StoreDashboardOverview,
  StoreDashboardQuery,
  StoreDashboardTopCategories,
  StoreDashboardTopProducts,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export type StoreDashboardSection =
  | 'overview'
  | 'app-active-users'
  | 'top-products'
  | 'top-categories'

const fetchStoreDashboardSection = async <T>(
  section: StoreDashboardSection,
  query: StoreDashboardQuery,
  signal?: AbortSignal,
): Promise<T> => {
  const response = await gozokiApiWithAuth.get<T>(`/stores/store-dashboard/${section}`, {
    params: query,
    signal,
  })
  return response.data
}

export const fetchStoreDashboardOverview = (query: StoreDashboardQuery, signal?: AbortSignal) =>
  fetchStoreDashboardSection<StoreDashboardOverview>('overview', query, signal)
export const fetchStoreDashboardActiveUsers = (query: StoreDashboardQuery, signal?: AbortSignal) =>
  fetchStoreDashboardSection<StoreDashboardActiveUsers>('app-active-users', query, signal)
export const fetchStoreDashboardTopProducts = (query: StoreDashboardQuery, signal?: AbortSignal) =>
  fetchStoreDashboardSection<StoreDashboardTopProducts>('top-products', query, signal)
export const fetchStoreDashboardTopCategories = (
  query: StoreDashboardQuery,
  signal?: AbortSignal,
) => fetchStoreDashboardSection<StoreDashboardTopCategories>('top-categories', query, signal)
